<script setup lang="ts">
defineProps({ blok: Object })
</script>

<template>
    <section class="section">
        <UiContainer max-width="max-w-3xl">
            <header class="mb-20 global-text text-center">
                <StoryblokRichText :doc="blok?.header" />
            </header>
        </UiContainer>
        <UiContainer>
            <div class="grid grid-cols-12 ">
                <StoryblokComponent
                    v-for="item in blok?.issues"
                    :key="item._uid"
                    v-editable="item"
                    :blok="item"
                    :solution="blok?.solution"
                    :issue="blok?.issue"
                />
            </div>
        </UiContainer>
    </section>
</template>
